import { ISetDescriptionParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetColumnDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setColumnDescription', {
      id: id,
      description: description
    });
  }
}
